'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import axios from 'axios';

export default function FirstVisitAttribution() {
  const searchParams = useSearchParams();
  const cookieName = 'MATTRIBUTION';
  useEffect(() => {
    const attributionParams = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
      'gclid',
      'fbclid',
      'msclkid',
    ];

    const arrAttributionParams: Record<string, string> = {};

    // Validate/sanitize incoming param values to prevent stored XSS before persisting to cookie
    const isSafeParam = (v: string) => {
      if (!v) return false;
      // reasonable length cap to avoid huge payloads
      if (v.length > 200) return false;

      // forbid obvious dangerous patterns / encoded variants
      const forbidden =
        /<|>|javascript:|data:|%3C|%3E|on\w+\s*=|eval\(|document\.cookie|window\./i;
      return !forbidden.test(v);
    };

    attributionParams.forEach((param) => {
      const raw = searchParams.get(param);
      if (raw) {
        const value = String(raw).trim();
        if (isSafeParam(value)) {
          arrAttributionParams[param] = value;
        } else {
          console.warn(`Ignored unsafe attribution param: ${param}`);
        }
      }
    });

    if (Object.keys(arrAttributionParams).length > 0) {
      try {
        const cookieValue = encodeURIComponent(
          JSON.stringify(arrAttributionParams)
        );
        const maxAge = 30 * 24 * 60 * 60;
        document.cookie = `${cookieName}=${cookieValue}; max-age=${maxAge}; path=/; Secure; SameSite=Lax`;
      } catch (err) {
        console.error('Failed to set MATTRIBUTION cookie', err);
      }
      void axios
        .post(
          `${process.env.NEXT_PUBLIC_ATTRIBUTION_API_URL ?? ''}/SUGboxAPI.cfm?go=c.captureMemberAttribution`,
          {
            attributionparams: arrAttributionParams,
          },
          {
            withCredentials: true, // This sends HTTP-only cookies
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .catch((error) => {
          console.error('Failed to capture attribution:', error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

// 'use client';

// import { useEffect } from 'react';
// import { useSearchParams } from 'next/navigation';
// import axios from 'axios';

// export default function FirstVisitAttribution() {
//   const searchParams = useSearchParams();

//   useEffect(() => {
//     const attributionParams = [
//       'utm_source',
//       'utm_medium',
//       'utm_campaign',
//       'utm_term',
//       'utm_content',
//       'gclid',
//       'fbclid',
//       'msclkid',
//     ];

//     const arrAttributionParams: Record<string, string> = {};

//     attributionParams.forEach((param) => {
//       const value = searchParams.get(param);
//       if (value) {
//         arrAttributionParams[param] = value;
//       }
//     });

//     if (Object.keys(arrAttributionParams).length > 0) {
//       void axios
//         .post('/api/attribution', {
//           attributionParams: arrAttributionParams,
//         })
//         .catch((error) => {
//           console.error('Failed to capture attribution:', error);
//         });
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   return null;
// }
